export function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function easeOutBack(t: number): number {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
}

interface ActiveTween {
  elapsed: number;
  duration: number;
  easing: (t: number) => number;
  onUpdate: (t: number) => void;
  resolve: () => void;
}

/** Gestionnaire de tweens "maison" (sans dependance) : un seul `update(dt)` par frame pilote toutes les animations en cours. */
export class TweenManager {
  private active: ActiveTween[] = [];

  animate(duration: number, onUpdate: (t: number) => void, easing: (t: number) => number = easeInOutCubic): Promise<void> {
    return new Promise((resolve) => {
      if (duration <= 0) {
        onUpdate(1);
        resolve();
        return;
      }
      this.active.push({ elapsed: 0, duration, easing, onUpdate, resolve });
    });
  }

  /** Fait avancer les tweens en cours ; retourne `true` si au moins un etait actif cette frame
   * (utilise par le rendu pour savoir si la geometrie a pu bouger, ex: invalidation des ombres). */
  update(dt: number): boolean {
    if (this.active.length === 0) return false;
    const stillActive: ActiveTween[] = [];
    for (const tween of this.active) {
      tween.elapsed += dt;
      const t = Math.min(1, tween.elapsed / tween.duration);
      tween.onUpdate(tween.easing(t));
      if (t < 1) {
        stillActive.push(tween);
      } else {
        tween.resolve();
      }
    }
    this.active = stillActive;
    return true;
  }
}
